import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { adminGetLinks, adminPutLinks } from "@/lib/api";

export default function LinksAdmin() {
  const [links, setLinks] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminGetLinks().then(setLinks).catch(() => toast.error("Failed to load links")); }, []);

  const update = (i, key, value) => setLinks((ls) => ls.map((l, j) => (j === i ? { ...l, [key]: value } : l)));

  const save = async () => {
    setSaving(true);
    try {
      await adminPutLinks(links);
      toast.success("Links saved");
    } catch { toast.error("Save failed"); }
    setSaving(false);
  };

  return (
    <div data-testid="admin-links">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display font-bold text-3xl text-[#1F3864] mb-1">Links & Buttons</h1>
          <p className="text-[#1F3864]/60">Point nav items and buttons at any section (#campaign) or page (/shop).</p>
        </div>
        <button data-testid="save-links-btn" onClick={save} disabled={saving}
          className="inline-flex items-center gap-2 bg-[#1F3864] text-[#D7E85C] font-bold px-5 py-3 rounded-full hover:bg-[#16294B] disabled:opacity-50">
          <Save size={16} /> {saving ? "Saving…" : "Save changes"}
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-[#1F3864]/10 divide-y divide-[#1F3864]/10">
        {links.map((l, i) => (
          <div key={l.id} className="p-4 grid sm:grid-cols-[1fr_1fr_1.5fr] gap-3 items-center">
            <span className="text-xs font-bold uppercase tracking-wider text-[#1F3864]/50">{l.id}</span>
            <input data-testid={`link-label-${l.id}`} value={l.label} onChange={(e) => update(i, "label", e.target.value)}
              className="border border-[#1F3864]/20 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#1F3864]" placeholder="Label" />
            <input data-testid={`link-href-${l.id}`} value={l.href} onChange={(e) => update(i, "href", e.target.value)}
              className="border border-[#1F3864]/20 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#1F3864]" placeholder="#section or /page" />
          </div>
        ))}
      </div>
    </div>
  );
}
